<div class="st-mos-story-send">
    <div class="st-mos-story-send-header">
        <span>{{ languageSettings.PSTWebMOSStorySend }}</span>
    </div>
    <div
        class="st-mos-story-send-content"
        [class.st-mos-story-send-content--disable-start-time]="!useMosStartTime()">
        <div class="st-mos-story-send-content__label">{{ languageSettings.PSTWebMosName }}</div>
        @if (useMosStartTime()) {
            <div class="st-mos-story-send-content__label">{{ languageSettings.PSTWebMOSStartTime }}</div>
        }
        @for (mos of localMosDevices(); track $index) {
            <div class="st-mos-story-send-content__mos-description">
                {{ mos.Description }}
                <mat-checkbox
                    [disabled]="mosControl()"
                    [checked]="mos.IsChecked"
                    (click)="onSelectedChange(mos)" />
            </div>
            @if (useMosStartTime()) {
                <st-date-time-picker
                    class="st-mos-story-send-content__time-picker"
                    type="time"
                    placeholder="00:00:00"
                    [disabled]="mosControl()"
                    (changed)="onTimeChange($event, mos.MOSID)" />
            }
        }
    </div>
    <div class="st-mos-story-send-footer">
        <button
            mat-button
            (click)="onEscape()">
            {{ languageSettings.PSTWebCancelButtonLabel }}
        </button>
        <button
            mat-flat-button
            class="st-mos-story-send-footer--save-btn"
            [disabled]="!anySelectedMosDevices() || mosControl()"
            (click)="save()">
            {{ languageSettings.PSTWebSaveOption }}
        </button>
    </div>
</div>
